import { useState, useCallback, useMemo } from 'react';
import { AgxBodyText, Images } from '@urbanx/agx-ui-components';
import { ErrorState } from 'types/Payable';
import {
  DepositPayable,
  FormCondition,
  Condition,
  DayType,
  SpecialConditionData,
} from '@urbanx/agx.campaigns.client';
import {
  AgxOnOrDaysFrom,
  AgxSpacer,
  ContractDateType,
} from '@urbanx/agx.ui-components2';

interface SettlementDatePayableProps {
  id: string;
  onValueChanged: (change: { id: string; value: FormCondition }) => void;
  defaultValue: FormCondition;
  validate?: boolean;
  required?: boolean;
  error?: ErrorState;
  specialConditions: SpecialConditionData[];
  campaignId: string;
}

const conditionsToInclude = [
  Condition.OnSpecificDate,
  Condition.UponSatisfactionOfSpecialCondition,
];

const SettlementDatePayable = ({
  id,
  defaultValue,
  onValueChanged,
  validate = false,
  specialConditions,
  campaignId,
}: SettlementDatePayableProps) => {
  const [settlementDateDetails, setSettlementDateDetails] =
    useState<FormCondition>({
      ...defaultValue,
      dayType: defaultValue?.dayType ?? DayType.Days,
      depositPayable: defaultValue?.depositPayable ?? DepositPayable.NDaysFrom,
    });

  const onConditionChange = useCallback(
    (value: FormCondition) => {
      const updatedValue: FormCondition = {
        ...settlementDateDetails,
        condition: value.condition,
        daysFromDate: value.daysFromDate,
        depositPayable: value.depositPayable,
        dayType: value.dayType,
        specialConditionId: value.specialConditionId,
        referenceDate: value.referenceDate,
        other: value.other,
      };

      setSettlementDateDetails(updatedValue);
      onValueChanged({
        id,
        value: updatedValue,
      });
    },
    [id, onValueChanged, settlementDateDetails]
  );

  return (
    <AgxOnOrDaysFrom
      id={id}
      condition={settlementDateDetails}
      conditionsToIncludeInDaysFrom={conditionsToInclude}
      conditionsToIncludeInOn={conditionsToInclude}
      includeContractDateTypeInOnOptions={false}
      specialConditions={specialConditions}
      campaignId={campaignId}
      validate={validate}
      defaultCondition={Condition.NdaysFromDate}
      onChange={onConditionChange}
      contractDateType={ContractDateType.ContractDate}
      onIsValidChange={() => {}}
    />
  );
};

export default SettlementDatePayable;
